import { useDocumentInstance } from 'bridge';
import { Group } from 'business';

export default function useGroup(groupId?: string) : Group | null | undefined {
    const group = useDocumentInstance('groups', groupId);
    return group;
}
